import { Fragment, useState, useContext } from 'react';
import { ViewContext, Card, Form, Icon, Button } from 'components/lib';
import Style from './feedback.module.scss';

export function Feedback({ isInNode = false, nodeName, labName }) {
  // context & state
  const context = useContext(ViewContext);
  const [showForm, setShowForm] = useState(isInNode);
  const [showComments, setShowComments] = useState(false);
  const [rating, setRating] = useState(null);
  const feedbackNodeTitle = isInNode
    ? context.t('global.feedback.title.nodes')
    : context.t('global.feedback.title.default');
  // maps
  const icons = ['smile', 'meh', 'frown'];
  const ratings = ['positive', 'neutral', 'negative'];
  const colors = ['green', 'orange', 'red'];

  function saveRating(rating){

    setRating(rating);
    setShowComments(true);

  }

  return (
    <section>

      {showForm ?
        <div className={Style.feedback}>
          <Card title={feedbackNodeTitle} className={Style.feedback}>
            <Button
              icon='x'
              color='dark'
              position='absolute'
              className={Style.close}
              size={16}
              action={e => setShowForm(false)}
            />

          <Fragment>
            <section className={ Style.rating }>
              { icons.map((icon, index) => {

                return (
                  <div key={ index } className={ Style.ratingButton } onClick={ () => saveRating(index) }>
                    <Icon 
                      image={ icon } 
                      color={ index === rating ? colors[index] : 'dark' }
                      className={ Style.ratingIcon }
                    />
                  </div> 
                );
              })}
            </section>

            { showComments && 
              <Form 
                inputs={{
                  rating: {
                  type: 'hidden',
                  value: ratings[rating]
                },
                  comment: {
                  label: context.t('global.feedback.form.comment.label'),
                  type: 'textarea',
                },
                  title: {
                  type: 'hidden',
                  value: nodeName || ''
                },
                  lab_title: {
                    type: 'hidden',
                    value: labName || ''
                }
                }}
                method='POST'
                url='/api/feedback'
                updateOnChange
                className={ Style.form }
                buttonText={ context.t('global.feedback.form.button') }
                onChange={ e => { return false }}
                callback={ e => {

                    setShowForm(false);
                    context.notification.show(context.t('global.feedback.form.success_message'), 'success', true, 'toast', 'heart');

                }}
              />
            }
          </Fragment>         
        </Card>
      </div> :

        <div className={ Style.button } onClick={ e => setShowForm(true) }>
          <Icon image='heart' color='white' className={ Style.icon } size={ 20 }/>
        </div>

      }
   </section>
  );
}